import React from "react";
import styles from './HousesList.module.scss';
import { AddressesList } from "../../ui/AddressesRegistrationForm/AddressesRegistrationForm";
import { generateAddress } from "../../../utils/generateAddress";

const HousesList = ({ housesData }) => {
  return (
    <div className={styles.conteiner}>
      {housesData?.map((house) => (
        <AddressesList key={house.houseId} company={house} address={generateAddress(house)}/>
      ))}
    </div>
  )
}

export default HousesList;